import LazyLoad from 'react-lazyload';
import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';
import ReactCompareImage from 'react-compare-image';
import Spinner from '../../src/components/ui/Spinner';

import { graphql } from 'gatsby';
import Img from 'gatsby-image';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

export const query = graphql`
  query {
    file(relativePath: { eq: "covers/bokeh-overlays.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1800) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

interface CompareWrapperProps {
  thin?: boolean;
}

const CompareWrapper = styled.div<CompareWrapperProps>`
  max-width: ${(props) => (props.thin ? '750px' : '100%')};
  margin: 0 auto 3rem;
`;

class RerenderCompare extends React.Component {
  t1;
  state = { delayOver: false };

  componentDidMount() {
    this.t1 = setTimeout(() => {
      this.setState({ delayOver: true });
    }, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.t1);
  }

  render() {
    if (!this.state.delayOver) {
      return <Spinner />;
    }
    return this.props.children();
  }
}

const ThumbWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  overflow: hidden;
  grid-gap: 0.75rem;

  img {
    object-fit: cover;
    height: 200px;
    width: 100%;
  }
  a {
    box-shadow: none;
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const PageTemplate = css`
  .header-image {
    margin-bottom: 4.5rem;
    box-shadow: 0 10px 20px -16px #382757;
  }

  .site-main {
    background #fff;
    padding-bottom: 4vw;
  }

  .post-content {
    max-width: 1000px;
    margin: 0 auto;
  }
  .post-content .large-key .key {
    font-size: 3rem;
    padding: 15px;
    margin-top: 20px;
    display: inline-block;
    border-radius: 6px;
  }
  .large-key {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 4rem;
  }

  @media(max-width: 400px) {
    .large-key {
      grid-template-columns: 1fr 1fr;
    }
  }

  h2::before {
    display: none !important;
  }
`;

const BokehOverlays: React.FunctionComponent = ({ data }) => (
  <IndexLayout>
    <Helmet>
      <title>220 Free High Resolution Bokeh Overlays for Photoshop | Giggster Guide</title>
      <meta
        name="description"
        content="A huge collection of free bokeh overlays that you can use right away to add beautiful soft effects to your photos in Photoshop."
      />

      <meta property="og:site_name" content="Giggster Guide" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="220 Free High Resolution Bokeh Overlays for Photoshop" />
      <meta
        property="og:description"
        content="A huge collection of free bokeh overlays that you can use right away to add beautiful soft effects to your photos in Photoshop."
      />
      <meta property="og:url" content="https://giggster.com/guide/bokeh-overlays/" />
      <meta property="og:image" content="https://giggster.com/guide/covers/bokeh-overlays.jpg" />
      <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="220 Free High Resolution Bokeh Overlays for Photoshop" />
      <meta
        name="twitter:description"
        content="A huge collection of free bokeh overlays that you can use right away to add beautiful soft effects to your photos in Photoshop."
      />
      <meta name="twitter:url" content="https://giggster.com/guide/bokeh-overlays/" />
      <meta name="twitter:image" content="https://giggster.com/guide/covers/bokeh-overlays.jpg" />
      <meta name="twitter:site" content="@Giggster" />
      <meta name="twitter:creator" content="@Giggster" />
      <script src="https://gumroad.com/js/gumroad.js"></script>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>220 Free High Resolution Bokeh Overlays for Photoshop</PostFullTitle>
            <h2 className="b3">
              Want to add beautiful ethereal bokeh to your photos using Photoshop? These free bokeh
              overlays will help you do just that! ✨
            </h2>
            <Img
              className="header-image"
              fluid={data.file.childImageSharp.fluid}
              alt="Example of a bokeh overlay used on a photo"
            />
            {/*<ShareButtons
              title={'220 Free High Resolution Bokeh Overlays for Photoshop'}
              slug={'/bokeh-overlays/'}
              imgSrc={'covers/bokeh-overlays.jpg'}
            />*/}
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
              <a href="#the_overlays">Jump right to the overlays</a>. Bokeh is this beautiful
                effect achieved by having lights in the background or foreground of an image being
                blurred up to the point of obtaining just soft circles of color.
              </p>
              <p>
                It's easiest to obtain beautiful bokeh when taking photographs using a wide-open
                aperture for a very shallow depth of field where the background and/or foreground
                gets really blurred-up.
              </p>

              <p>
                Oftentimes you won't be able to capture the bokeh that you would have wanted
                straight in camera. There's an easy fix for that, just add it afterward as an
                overlay to the image! To help with this, I've prepared a collection of 220 free
                bokeh overlays that you can use in Photoshop. These were created by taking real
                photographs, so that will have this real organic feel to them.
              </p>

              {/* <section className="info-box">
                <h3 className="text-center">😮 How about 110 more?</h3>
                <p className="text-center">
                  If you'd like even more bokeh overlays to choose from, I've decided to put
                  together a pack with 110 more stunning overlays. Same style and quality, just
                  double the amount to select from.
                </p>

                <p className="text-center">
                  Just click the button below to <strong>purchase securely via Gumroad</strong>:
                </p>
                <p className="text-center">
                  <a className="gumroad-button" href="https://gum.co/GuzjZ" target="_blank">
                    Buy my product for $11.11
                  </a>
                </p>
              </section> */}

              <hr />

              <h3 className="text-center">Bokeh Overlay Usage Example</h3>

              <CompareWrapper thin>
                <RerenderCompare>
                  {() => (
                    <ReactCompareImage
                      sliderPositionPercentage={0.5}
                      leftImage="/guide/images/bokeh-overlays/examples/bokeh-overlay-before.jpg"
                      rightImage="/guide/images/bokeh-overlays/examples/bokeh-overlay-after2.jpg"
                      sliderLineWidth={4}
                      skeleton={<Spinner />}
                    />
                  )}
                </RerenderCompare>
              </CompareWrapper>

              <p>Here's the summary of the steps I've taken to add the overlay:</p>

              <ol>
                <li>Added my overlay as a new layer.</li>
                <li>Converted the layer to a smart object.</li>
                <li>
                  Rotated and resized the layer so that it falls at the right place for the photo.
                </li>
                <li>Applied at slight gaussian blur to the overlay layer.</li>
                <li>
                  Added a Hue/Saturation adjustment layer, clipped to the overlay layer so that it
                  only affects the overlay. I checked the
                  <em>Colorize</em> option and I selected a Hue value that approximates the color of
                  the eye makeup.
                </li>
              </ol>

              <p>And here's a screenshot that should help illustrate those steps:</p>

              <figure className="text-center screenshot">
                <img
                  src="/guide/images/bokeh-overlays/examples/screens/bokeh-overlays00.jpg"
                  alt="Adding the overlay in Photoshop"
                />
                <figcaption>
                  The model in that fashion portrait is{' '}
                  <a href="https://www.instagram.com/ShannonBaker/">
                    <strong>Shannon Baker</strong>
                  </a>
                  . Go follow her!
                </figcaption>
              </figure>

              <hr />

              <section className="info-box">
                <h3 className="text-center">Using the Bokeh Overlays</h3>

                <p className="text-center">
                  I <a href="/guide/retouching/using-textures/">wrote up a post</a> about how to use
                  texture overlays in Photoshop. Very similar principles apply to using these bokeh
                  overlays. You'll add the overlay as a new layer on top of your image and then
                  change the layer blend mode to <strong>Screen</strong>. You can apply a gaussian
                  blur to the overlay layer to make the bokeh more diffuse and blurry. And you also
                  can apply a hue/saturation adjustment layer clipped to the overlay layer to change
                  the overall hue (color) of the overlay.
                </p>
              </section>

              <section className="info-box">
                <h3 className="text-center">Pro tip: Don't mind the color</h3>

                <p className="text-center">
                  When choosing the perfect bokeh overlay for your photo, don't worry too much about
                  the color of the bokeh. You can pretty easily colorize the overlay layer using
                  Photoshop and have it be the color that you want. What you'll want to pay most
                  attention to is the size and distribution of the bokeh in the overlay.
                </p>
                <p className="text-center">
                  Also remember that you can easily add more than one overlay to an image. You can
                  use the same one at multiple places, erase part of one, rotate them, resize
                  them... The sky is the limit! ☁️
                </p>
              </section>

              <hr />

              <h2 id="the_overlays" className="text-center">
                Free Photoshop Bokeh Overlays
              </h2>
              <p >
                Below you can see thumbnails for the 220 Free Bokeh overlays. Just click on any of
                the thumbnails to download a full high resolution version of the overlay.
              </p>

             

              <ThumbWrapper>
                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-1.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-1.jpg" alt="Bokeh overlay 1" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-2.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-2.jpg" alt="Bokeh overlay 2" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-3.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-3.jpg" alt="Bokeh overlay 3" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-4.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-4.jpg" alt="Bokeh overlay 4" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-5.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-5.jpg" alt="Bokeh overlay 5" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-6.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-6.jpg" alt="Bokeh overlay 6" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-7.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-7.jpg" alt="Bokeh overlay 7" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-8.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-8.jpg" alt="Bokeh overlay 8" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-9.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-9.jpg" alt="Bokeh overlay 9" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-10.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-10.jpg" alt="Bokeh overlay 10" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-11.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-11.jpg" alt="Bokeh overlay 11" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-12.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-12.jpg" alt="Bokeh overlay 12" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-13.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-13.jpg" alt="Bokeh overlay 13" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-14.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-14.jpg" alt="Bokeh overlay 14" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-15.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-15.jpg" alt="Bokeh overlay 15" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-16.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-16.jpg" alt="Bokeh overlay 16" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-17.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-17.jpg" alt="Bokeh overlay 17" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-18.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-18.jpg" alt="Bokeh overlay 18" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-19.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-19.jpg" alt="Bokeh overlay 19" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-20.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-20.jpg" alt="Bokeh overlay 20" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-21.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-21.jpg" alt="Bokeh overlay 21" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-22.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-22.jpg" alt="Bokeh overlay 22" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-23.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-23.jpg" alt="Bokeh overlay 23" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-24.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-24.jpg" alt="Bokeh overlay 24" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-25.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-25.jpg" alt="Bokeh overlay 25" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-26.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-26.jpg" alt="Bokeh overlay 26" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-27.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-27.jpg" alt="Bokeh overlay 27" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-28.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-28.jpg" alt="Bokeh overlay 28" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-29.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-29.jpg" alt="Bokeh overlay 29" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-30.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-30.jpg" alt="Bokeh overlay 30" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-31.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-31.jpg" alt="Bokeh overlay 31" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-32.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-32.jpg" alt="Bokeh overlay 32" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-33.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-33.jpg" alt="Bokeh overlay 33" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-34.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-34.jpg" alt="Bokeh overlay 34" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-35.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-35.jpg" alt="Bokeh overlay 35" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-36.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-36.jpg" alt="Bokeh overlay 36" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-37.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-37.jpg" alt="Bokeh overlay 37" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-38.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-38.jpg" alt="Bokeh overlay 38" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-39.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-39.jpg" alt="Bokeh overlay 39" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-40.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-40.jpg" alt="Bokeh overlay 40" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-41.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-41.jpg" alt="Bokeh overlay 41" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-42.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-42.jpg" alt="Bokeh overlay 42" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-43.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-43.jpg" alt="Bokeh overlay 43" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-44.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-44.jpg" alt="Bokeh overlay 44" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-45.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-45.jpg" alt="Bokeh overlay 45" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-46.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-46.jpg" alt="Bokeh overlay 46" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-47.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-47.jpg" alt="Bokeh overlay 47" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-48.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-48.jpg" alt="Bokeh overlay 48" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-49.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-49.jpg" alt="Bokeh overlay 49" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-50.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-50.jpg" alt="Bokeh overlay 50" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-51.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-51.jpg" alt="Bokeh overlay 51" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-52.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-52.jpg" alt="Bokeh overlay 52" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-53.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-53.jpg" alt="Bokeh overlay 53" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-54.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-54.jpg" alt="Bokeh overlay 54" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-55.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-55.jpg" alt="Bokeh overlay 55" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-56.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-56.jpg" alt="Bokeh overlay 56" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-57.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-57.jpg" alt="Bokeh overlay 57" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-58.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-58.jpg" alt="Bokeh overlay 58" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-59.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-59.jpg" alt="Bokeh overlay 59" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-60.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-60.jpg" alt="Bokeh overlay 60" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-61.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-61.jpg" alt="Bokeh overlay 61" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-62.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-62.jpg" alt="Bokeh overlay 62" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-63.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-63.jpg" alt="Bokeh overlay 63" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-64.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-64.jpg" alt="Bokeh overlay 64" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-65.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-65.jpg" alt="Bokeh overlay 65" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-66.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-66.jpg" alt="Bokeh overlay 66" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-67.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-67.jpg" alt="Bokeh overlay 67" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-68.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-68.jpg" alt="Bokeh overlay 68" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-69.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-69.jpg" alt="Bokeh overlay 69" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-70.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-70.jpg" alt="Bokeh overlay 70" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-71.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-71.jpg" alt="Bokeh overlay 71" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-72.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-72.jpg" alt="Bokeh overlay 72" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-73.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-73.jpg" alt="Bokeh overlay 73" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-74.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-74.jpg" alt="Bokeh overlay 74" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-75.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-75.jpg" alt="Bokeh overlay 75" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-76.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-76.jpg" alt="Bokeh overlay 76" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-77.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-77.jpg" alt="Bokeh overlay 77" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-78.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-78.jpg" alt="Bokeh overlay 78" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-79.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-79.jpg" alt="Bokeh overlay 79" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-80.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-80.jpg" alt="Bokeh overlay 80" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-81.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-81.jpg" alt="Bokeh overlay 81" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-82.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-82.jpg" alt="Bokeh overlay 82" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-83.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-83.jpg" alt="Bokeh overlay 83" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-84.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-84.jpg" alt="Bokeh overlay 84" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-85.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-85.jpg" alt="Bokeh overlay 85" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-86.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-86.jpg" alt="Bokeh overlay 86" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-87.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-87.jpg" alt="Bokeh overlay 87" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-88.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-88.jpg" alt="Bokeh overlay 88" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-89.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-89.jpg" alt="Bokeh overlay 89" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-90.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-90.jpg" alt="Bokeh overlay 90" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-91.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-91.jpg" alt="Bokeh overlay 91" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-92.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-92.jpg" alt="Bokeh overlay 92" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-93.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-93.jpg" alt="Bokeh overlay 93" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-94.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-94.jpg" alt="Bokeh overlay 94" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-95.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-95.jpg" alt="Bokeh overlay 95" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-96.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-96.jpg" alt="Bokeh overlay 96" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-97.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-97.jpg" alt="Bokeh overlay 97" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-98.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-98.jpg" alt="Bokeh overlay 98" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-99.jpg"
                    rel="noreferrer noopener"
                  >
                    <img src="/guide/images/bokeh-overlays/bokeh-overlay-99.jpg" alt="Bokeh overlay 99" />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-100.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-100.jpg"
                      alt="Bokeh overlay 100"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-101.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-101.jpg"
                      alt="Bokeh overlay 101"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-102.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-102.jpg"
                      alt="Bokeh overlay 102"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-103.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-103.jpg"
                      alt="Bokeh overlay 103"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-104.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-104.jpg"
                      alt="Bokeh overlay 104"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-105.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-105.jpg"
                      alt="Bokeh overlay 105"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-106.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-106.jpg"
                      alt="Bokeh overlay 106"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-107.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-107.jpg"
                      alt="Bokeh overlay 107"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-108.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-108.jpg"
                      alt="Bokeh overlay 108"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-109.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-109.jpg"
                      alt="Bokeh overlay 109"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-110.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-110.jpg"
                      alt="Bokeh overlay 110"
                    />
                  </a>
                </LazyLoad>
                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-111.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-111.jpg"
                      alt="Bokeh overlay 111"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-112.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-112.jpg"
                      alt="Bokeh overlay 112"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-113.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-113.jpg"
                      alt="Bokeh overlay 113"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-114.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-114.jpg"
                      alt="Bokeh overlay 114"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-115.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-115.jpg"
                      alt="Bokeh overlay 115"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-116.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-116.jpg"
                      alt="Bokeh overlay 116"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-117.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-117.jpg"
                      alt="Bokeh overlay 117"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-118.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-118.jpg"
                      alt="Bokeh overlay 118"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-119.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-119.jpg"
                      alt="Bokeh overlay 119"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-120.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-120.jpg"
                      alt="Bokeh overlay 120"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-121.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-121.jpg"
                      alt="Bokeh overlay 121"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-122.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-122.jpg"
                      alt="Bokeh overlay 122"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-123.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-123.jpg"
                      alt="Bokeh overlay 123"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-124.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-124.jpg"
                      alt="Bokeh overlay 124"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-125.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-125.jpg"
                      alt="Bokeh overlay 125"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-126.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-126.jpg"
                      alt="Bokeh overlay 126"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-127.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-127.jpg"
                      alt="Bokeh overlay 127"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-128.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-128.jpg"
                      alt="Bokeh overlay 128"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-129.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-129.jpg"
                      alt="Bokeh overlay 129"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-130.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-130.jpg"
                      alt="Bokeh overlay 130"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-131.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-131.jpg"
                      alt="Bokeh overlay 131"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-132.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-132.jpg"
                      alt="Bokeh overlay 132"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-133.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-133.jpg"
                      alt="Bokeh overlay 133"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-134.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-134.jpg"
                      alt="Bokeh overlay 134"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-135.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-135.jpg"
                      alt="Bokeh overlay 135"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-136.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-136.jpg"
                      alt="Bokeh overlay 136"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-137.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-137.jpg"
                      alt="Bokeh overlay 137"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-138.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-138.jpg"
                      alt="Bokeh overlay 138"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-139.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-139.jpg"
                      alt="Bokeh overlay 139"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-140.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-140.jpg"
                      alt="Bokeh overlay 140"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-141.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-141.jpg"
                      alt="Bokeh overlay 141"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-142.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-142.jpg"
                      alt="Bokeh overlay 142"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-143.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-143.jpg"
                      alt="Bokeh overlay 143"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-144.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-144.jpg"
                      alt="Bokeh overlay 144"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-145.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-145.jpg"
                      alt="Bokeh overlay 145"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-146.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-146.jpg"
                      alt="Bokeh overlay 146"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-147.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-147.jpg"
                      alt="Bokeh overlay 147"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-148.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-148.jpg"
                      alt="Bokeh overlay 148"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-149.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-149.jpg"
                      alt="Bokeh overlay 149"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-150.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-150.jpg"
                      alt="Bokeh overlay 150"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-151.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-151.jpg"
                      alt="Bokeh overlay 151"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-152.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-152.jpg"
                      alt="Bokeh overlay 152"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-153.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-153.jpg"
                      alt="Bokeh overlay 153"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-154.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-154.jpg"
                      alt="Bokeh overlay 154"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-155.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-155.jpg"
                      alt="Bokeh overlay 155"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-156.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-156.jpg"
                      alt="Bokeh overlay 156"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-157.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-157.jpg"
                      alt="Bokeh overlay 157"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-158.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-158.jpg"
                      alt="Bokeh overlay 158"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-159.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-159.jpg"
                      alt="Bokeh overlay 159"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-160.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-160.jpg"
                      alt="Bokeh overlay 160"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-161.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-161.jpg"
                      alt="Bokeh overlay 161"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-162.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-162.jpg"
                      alt="Bokeh overlay 162"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-163.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-163.jpg"
                      alt="Bokeh overlay 163"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-164.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-164.jpg"
                      alt="Bokeh overlay 164"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-165.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-165.jpg"
                      alt="Bokeh overlay 165"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-166.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-166.jpg"
                      alt="Bokeh overlay 166"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-167.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-167.jpg"
                      alt="Bokeh overlay 167"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-168.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-168.jpg"
                      alt="Bokeh overlay 168"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-169.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-169.jpg"
                      alt="Bokeh overlay 169"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-170.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-170.jpg"
                      alt="Bokeh overlay 170"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-171.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-171.jpg"
                      alt="Bokeh overlay 171"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-172.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-172.jpg"
                      alt="Bokeh overlay 172"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-173.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-173.jpg"
                      alt="Bokeh overlay 173"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-174.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-174.jpg"
                      alt="Bokeh overlay 174"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-175.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-175.jpg"
                      alt="Bokeh overlay 175"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-176.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-176.jpg"
                      alt="Bokeh overlay 176"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-177.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-177.jpg"
                      alt="Bokeh overlay 177"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-178.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-178.jpg"
                      alt="Bokeh overlay 178"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-179.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-179.jpg"
                      alt="Bokeh overlay 179"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-180.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-180.jpg"
                      alt="Bokeh overlay 180"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-181.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-181.jpg"
                      alt="Bokeh overlay 181"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-182.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-182.jpg"
                      alt="Bokeh overlay 182"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-183.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-183.jpg"
                      alt="Bokeh overlay 183"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-184.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-184.jpg"
                      alt="Bokeh overlay 184"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-185.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-185.jpg"
                      alt="Bokeh overlay 185"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-186.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-186.jpg"
                      alt="Bokeh overlay 186"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-187.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-187.jpg"
                      alt="Bokeh overlay 187"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-188.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-188.jpg"
                      alt="Bokeh overlay 188"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-189.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-189.jpg"
                      alt="Bokeh overlay 189"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-190.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-190.jpg"
                      alt="Bokeh overlay 190"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-191.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-191.jpg"
                      alt="Bokeh overlay 191"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-192.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-192.jpg"
                      alt="Bokeh overlay 192"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-193.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-193.jpg"
                      alt="Bokeh overlay 193"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-194.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-194.jpg"
                      alt="Bokeh overlay 194"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-195.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-195.jpg"
                      alt="Bokeh overlay 195"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-196.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-196.jpg"
                      alt="Bokeh overlay 196"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-197.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-197.jpg"
                      alt="Bokeh overlay 197"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-198.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-198.jpg"
                      alt="Bokeh overlay 198"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-199.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-199.jpg"
                      alt="Bokeh overlay 199"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-200.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-200.jpg"
                      alt="Bokeh overlay 200"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-201.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-201.jpg"
                      alt="Bokeh overlay 201"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-202.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-202.jpg"
                      alt="Bokeh overlay 202"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-203.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-203.jpg"
                      alt="Bokeh overlay 203"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-204.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-204.jpg"
                      alt="Bokeh overlay 204"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-205.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-205.jpg"
                      alt="Bokeh overlay 205"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-206.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-206.jpg"
                      alt="Bokeh overlay 206"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-207.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-207.jpg"
                      alt="Bokeh overlay 207"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-208.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-208.jpg"
                      alt="Bokeh overlay 208"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-209.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-209.jpg"
                      alt="Bokeh overlay 209"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-210.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-210.jpg"
                      alt="Bokeh overlay 210"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-211.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-211.jpg"
                      alt="Bokeh overlay 211"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-212.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-212.jpg"
                      alt="Bokeh overlay 212"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-213.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-213.jpg"
                      alt="Bokeh overlay 213"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-214.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-214.jpg"
                      alt="Bokeh overlay 214"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-215.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-215.jpg"
                      alt="Bokeh overlay 215"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-216.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-216.jpg"
                      alt="Bokeh overlay 216"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-217.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-217.jpg"
                      alt="Bokeh overlay 217"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-218.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-218.jpg"
                      alt="Bokeh overlay 218"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-219.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-219.jpg"
                      alt="Bokeh overlay 219"
                    />
                  </a>
                </LazyLoad>

                <LazyLoad height={200}>
                  <a
                    target="_blank"
                    download
                    href="/guide/images/bokeh-overlays/full/bokeh-overlay-220.jpg"
                    rel="noreferrer noopener"
                  >
                    <img
                      src="/guide/images/bokeh-overlays/bokeh-overlay-220.jpg"
                      alt="Bokeh overlay 220"
                    />
                  </a>
                </LazyLoad>
              </ThumbWrapper>
            </div>
          </PostFullContent>
        </article>
        <MoreGoodies slug="bokeh-overlays" />
      </main>
      <BackToTop />
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default BokehOverlays;
